import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

/**
 * Pixel viewfinder brackets framing the `CodesmithIcon` anvil on an 18-cell
 * grid, so every cell lands on one pixel at the 18px nav size.
 */
const PROOF_PIXELS =
  "M0 0h4v1H1v3H0zM14 0h4v4h-1V1h-3zM0 14h1v3h3v1H0zM17 14h1v4h-4v-1h3z" +
  "M4 5h10v1H4zM14 6h1v6h-1zM3 6h1v4H3zM4 9h1v1H4zM5 10h1v1H5zM6 11h1v2H6zM7 12h7v1H7z" +
  "M8 7h1v3H8zM11 7h1v3h-1z";

/** Every surface that identifies Proof renders this glyph, never a lucide icon of its own. */
export const ProofIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  function ProofIcon({ size = 24, ...props }, ref) {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="currentColor"
        aria-hidden
        {...props}
      >
        <path d={PROOF_PIXELS} />
      </svg>
    );
  },
);
